import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=5ccbeaaa&scoped=true&"
import script from "./dashboard.ts?vue&type=script&lang=ts&"
export * from "./dashboard.ts?vue&type=script&lang=ts&"
import style0 from "./dashboard.scss?vue&type=style&index=0&id=5ccbeaaa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccbeaaa",
  null
  
)

export default component.exports